import React, { useRef, useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router, hashHistory } from 'react-router';
import { locale, language } from '@tcc/i18n';
import { attachToGlobal } from '@tcc/treadstone'
import { getIdsFromHash } from './utils/url';
import { reqAppInitializer } from './actions/appInitializerActions';
import { MULTI_OPERATION_SELECTION } from './constants/featureFlags';
import { setupAllSteps } from './boot/config';
import routes from './routes';
import configureStore from './store';
import { experimentalRedirect } from './boot/libs';
import { receiveOperations, receiveMultipleOperations } from './actions/operationsActions';
import { DmbQueryClientProvider } from './providers/DmbQueryClientProvider';
import './global.css';

function DmbPlugin({ operations, operationsSelected }) {
  const [bootstrapped, setBootstrapped] = useState(false);
  const store = useRef();
  const [isProxying, setIsProxying] = useState(false);

  useEffect(() => {
    attachToGlobal();
    setupAllSteps().then(({ nav, env, auth }) => {
      const { currentUser, user } = auth;
      
      setIsProxying(user.isProxying);
      experimentalRedirect({ name: env.name, href: env.href });
      
      const storeConfig = {
        currentUser,
        user,
        app: {
          locale,
          language,
          ...env,
          nav: {
            ...nav,
          },
        },
      };
      store.current = configureStore(storeConfig);

      const { fieldId, mapLayerIds, seasonIds } = getIdsFromHash();

      store.current.dispatch(
        reqAppInitializer(fieldId, mapLayerIds, seasonIds)
      );
      setBootstrapped(true);
    });
  }, []);

  if (!bootstrapped) return null;

  const history = hashHistory;

  if (!isProxying && operations?.length) {
    const state = store.current.getState();
    if (state.feature.userConfigFeatures[MULTI_OPERATION_SELECTION]?.value) {
      store.current.dispatch(receiveMultipleOperations(operationsSelected, operations))
    } else {
      store.current.dispatch(receiveOperations(operationsSelected[0], operations))
    }
  }
  
  return (
    <DmbQueryClientProvider>
      <Provider store={store.current}>
        <Router
          history={history}
          routes={routes('/dmb')}
        />
      </Provider>
    </DmbQueryClientProvider>
  );
}

export default DmbPlugin;
